export function askDaiHref(location, open = true) {
  const params = new URLSearchParams(location.search);
  if (open) params.set('chat', 'ask-dai');
  else params.delete('chat');
  return `${location.pathname}${params.size ? `?${params}` : ''}${location.hash || ''}`;
}

// Dialog history changes should not reset the underlying page's focus or scroll.
export function isAskDaiNavigation(previous, next) {
  if (!previous || previous.pathname !== next.pathname || previous.hash !== next.hash) return false;
  const before = new URLSearchParams(previous.search);
  const after = new URLSearchParams(next.search);
  if (before.get('chat') !== 'ask-dai' && after.get('chat') !== 'ask-dai') return false;
  before.delete('chat');
  after.delete('chat');
  return before.toString() === after.toString();
}
